import { StateSchema } from 'app/config/storeConfig/types';
import { Box } from 'entities/Box';

export const getSelectedBoxes = (state: StateSchema): Box[] => state.sendOfferModal.selectedBoxes;
